import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularFireDatabase, AngularFireList  } from 'angularfire2/database';
import { Todo } from '../class/todo';
import { MatSnackBar } from '@angular/material';
import { CompletedComponent } from './completed/completed.component';
import { DialogComponent } from './dialog/dialog.component';
import { PassPipe } from '../pipe/pass.pipe'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TotalkComponent } from './totalk/totalk.component';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.css']
})
export class TopComponent implements OnInit {

  isLinear = true;

  wantFormGroup: FormGroup;
  whyFormGroup: FormGroup;
  difficultyFormGroup: FormGroup;
  hopeFormGroup: FormGroup;
  periodFormGroup: FormGroup;
  challengeFormGroup: FormGroup;
  achievementFormGroup: FormGroup;

  want:string
  why:string
  difficulty:string
  hope:string
  period:string
  challenge:string
  achievement:number
  color:string

  todos: Todo[];
  todosRef: AngularFireList<any>;

  text: string;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private db: AngularFireDatabase,
    public snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { 
      this.todosRef = this.db.list('todos');
    }
    

  openSnackBar() {
    this.snackBar.openFromComponent(CompletedComponent, {
      duration: 1000,
    });
  }

  public snackObservable: Observable<any> = new Observable((observer => {
    observer.next(
      this.snackBar.openFromComponent(TotalkComponent, {
        verticalPosition: 'top',
        duration: 3000,
        data: {text: 'ようこそヤルカミへ', first:  true}
      })
    )
    // for ( var i = 1 ; i < 10 ; i++ ){
    //   setTimeout(()=> {
    //     observer.next(
    //       this.snackBar.openFromComponent(TotalkComponent, {
    //         verticalPosition: 'top',
    //         duration: 3000,
    //         data: '私はヤルカミ見習いのシン'
    //       })
    //     )
    //   }, 3000*i)
    // }
    setTimeout(()=> {
        observer.next(
          this.snackBar.openFromComponent(TotalkComponent, {
            verticalPosition: 'top',
            duration: 3000,
            data: {text: '私はヤルカミ見習いのシン', first:  true}
          })
        )
    }, 3000)
    setTimeout(()=> {
      observer.next(
        this.snackBar.openFromComponent(TotalkComponent, {
          verticalPosition: 'top',
          duration: 3000,
          data: {text: 'みんなの願い事をここに入力して欲しい', first:  true}
        })
      )
    }, 6000)
    setTimeout(()=> {
      observer.next(
        this.snackBar.openFromComponent(TotalkComponent, {
          verticalPosition: 'top',
          duration: 3000,
          data: {text: '私は願い事を聞いたぶん、ヤルカミに近づける', first:  true}
        })
      )
    }, 9000)
    setTimeout(()=> {
      observer.next(
        this.snackBar.openFromComponent(TotalkComponent, {
          verticalPosition: 'top',
          duration: 3000,
          data: {text: '未熟だからといってなめるなよ', first:  true}
        })
      )
    }, 12000)
    setTimeout(()=> {
      observer.next(
        this.snackBar.openFromComponent(TotalkComponent, {
          verticalPosition: 'top',
          duration: 3000,
          data: {text: '完璧ではないが未熟でもない・・・', first:  true}
        })
      )
    }, 15000)
    setTimeout(()=> {
      observer.next(
        this.snackBar.openFromComponent(TotalkComponent, {
          verticalPosition: 'top',
          duration: 3000,
          data: {text: 'さあ、君の願いを聞かせてくれ！', first:  true}
        })
      )
    }, 18000)
  }))

  firsttotalkSnackBar() {
    this.snackObservable.subscribe()
  }

  totalkSnackBar() {
    this.snackBar.openFromComponent(TotalkComponent, {
      verticalPosition: 'top',
      duration: 3000,
      data: this.text
    })
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(DialogComponent, {
      width: '30vw',
      data:　{want: this.want, achievement: this.achievement}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result){
        this.ToDoPush()
        this.openSnackBar();
        this.router.navigate(['/dashboad']);
      }
    });
  }

  ngOnInit() {
    this.wantFormGroup = this.fb.group({
      want: [null, Validators.required]
    });
    this.whyFormGroup = this.fb.group({
      why: [null, Validators.required]
    });
    this.difficultyFormGroup = this.fb.group({
      difficulty: [null, Validators.required]
    });
    this.hopeFormGroup = this.fb.group({
      hope: [null, Validators.required]
    });
    this.periodFormGroup = this.fb.group({
      period: [null, Validators.required]
    });
    this.challengeFormGroup = this.fb.group({
      challenge: [null, Validators.required]
    });
    this.achievementFormGroup = this.fb.group({
      achievement: [null, Validators.required]
    });

  }


  addWant(want) {
    this.want = want.want;
    this.text = want.want + "・・・か、良い願いだな";
    this.snackBar.openFromComponent(TotalkComponent, {
      verticalPosition: 'top',
      duration: 3000,
      data: {text: this.text, good: true}
    })
  }

  addWhy(why) {
    this.why = why.why;
    this.text = why.why + "・・・か、真剣に考えているのか？";
    this.snackBar.openFromComponent(TotalkComponent, {
      verticalPosition: 'top',
      duration: 3000,
      data: {text: this.text, ridiculed: true}
    })
  }

  addDifficulty(difficulty) {
    this.difficulty = difficulty.difficulty;
    this.text = difficulty.difficulty + "・・・か、応援しているぞ";
    this.snackBar.openFromComponent(TotalkComponent, {
      verticalPosition: 'top',
      duration: 3000,
      data: {text: this.text, sorrow: true}
    })
  }

  addHope(hope) {
    this.hope = hope.hope;
    this.text = hope.hope + "・・・か、すごいな";
    this.snackBar.openFromComponent(TotalkComponent, {
      verticalPosition: 'top',
      duration: 3000,
      data: {text: this.text, surprised: true}
    })
  }
  
  addPeriod(period) {
    this.period = period.period;
    this.text = period.period;
  }

  addChallenge(challenge) {
    this.challenge = challenge.challenge;
    this.text = challenge.challenge;
  }

  addAchievement(achievement) {
    this.achievement = achievement.achievement;
    this.text = "君の願い　『" + this.want + "』　叶いますように"
    this.snackBar.openFromComponent(TotalkComponent, {
      verticalPosition: 'top',
      duration: 7000,
      data: {text: this.text, body: true}
    })
  }

  ToDoPush(){
    if(this.achievement > 90){
      this.color = 'primary'
    }else if(this.achievement > 75){
      this.color = 'accent'
    }else{
      this.color = 'warn'
    }
    this.todosRef.push(new Todo({
      want: this.want, 
      why: this.why,
      difficulty: this.difficulty,
      hope: this.hope,
      period: this.period,
      challenge: this.challenge,
      achievement: this.achievement,
      color: this.color
    }))
  }
}


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/top/top.component.ts